export default "__VITE_ASSET__CoBkCA2b__"